"use client"

const ButtonTextIcon = ({ icon, title, iconPosition, ...rest }) => {
    return (
      <button {...rest}>
        <span>
          {iconPosition === "start" ? icon : null}
          <span style={{paddingLeft: "6px"}} className="f-w-400">{title}</span>
          {iconPosition === "end" ? icon : null}
        </span>
      </button>
    );
  };
  
  export default ButtonTextIcon;